import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "container-fluid wrapper" }
const _hoisted_2 = {
  key: 0,
  class: "container-fluid"
}
const _hoisted_3 = { class: "content" }
const _hoisted_4 = {
  key: 1,
  class: "container-fluid"
}

import { reactive } from 'vue'
import PlotControls, { PlotControlProps } from './components/PlotControls.vue'
import MetricPanel, { MetricProps } from './components/MetricPanel.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  props: {
    title: {},
    footer: {},
    globals: {},
    metrics: {}
  },
  setup(__props: any) {

const props = __props

const globalControls = reactive(props.globals)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.title)
      ? (_openBlock(), _createElementBlock("header", _hoisted_2, [
          _createElementVNode("h2", null, _toDisplayString(__props.title), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("aside", null, [
        _cache[0] || (_cache[0] = _createElementVNode("h4", null, "Global Parameters", -1)),
        _createVNode(PlotControls, { controls: globalControls }, null, 8, ["controls"])
      ]),
      _createElementVNode("main", null, [
        _cache[1] || (_cache[1] = _createStaticVNode("<h4 data-v-16a4496a>Overview</h4><article data-v-16a4496a><details open data-v-16a4496a><summary data-v-16a4496a>What is Peras?</summary><p data-v-16a4496a> Peras, or more precisely Ouroboros Peras, is an extension of Ouroboros Praos that addresses one of the known issues of blockchains based on Nakamoto-style consensus, namely settlement time. Peras achieves that goal while being self-healing, preserving the security of Praos, and being light on resources. </p></details><details open data-v-16a4496a><summary data-v-16a4496a>About this dashboard</summary><p data-v-16a4496a> The global parameters to the left apply to all metrics below. In addition, each metric may have its own specific parameters that you can adjust. Use the controls to see how the metrics change in real-time. </p></details><details open data-v-16a4496a><summary data-v-16a4496a>Resources</summary><ul data-v-16a4496a><li data-v-16a4496a><a href=\"https://github.com/cardano-foundation/CIPs/blob/master/CIP-0140/README.md\" data-v-16a4496a> Peras CIP (CIP-0140) </a></li><li data-v-16a4496a><a href=\"https://peras.cardano-scaling.org/dashboard/index.html\" data-v-16a4496a> Original Peras dashboard </a></li><li data-v-16a4496a><a href=\"https://eprint.iacr.org/2022/1571.pdf\" data-v-16a4496a> Practical Settlement Bounds for Longest-Chain Consensus </a></li><li data-v-16a4496a><a href=\"https://github.com/renling/LCanalysis\" data-v-16a4496a> Numeric evaluation of longest-chain PoW and PoS blockchains </a></li><li data-v-16a4496a><a href=\"https://tweag.github.io/cardano-peras/peras-design.pdf\" data-v-16a4496a> Peras design document </a></li></ul></details></article><h4 data-v-16a4496a>Metrics</h4>", 3)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.metrics, (metric, index) => {
          return (_openBlock(), _createBlock(MetricPanel, {
            key: index,
            title: metric.title,
            description: metric.description,
            axes: metric.axes,
            legend: metric.legend,
            globals: globalControls,
            controls: reactive(metric.controls),
            compute: metric.compute,
            open: index === 0
          }, null, 8, ["title", "description", "axes", "legend", "globals", "controls", "compute", "open"]))
        }), 128))
      ])
    ]),
    (__props.footer)
      ? (_openBlock(), _createElementBlock("footer", _hoisted_4, _toDisplayString(__props.footer), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})